export default __webpack_public_path__ + "static/media/vector.0d38d4f1.svg";